import { styled, Theme } from "@mui/material/styles"
import Stack from "@mui/material/Stack"

type SliderProgressBarProps = {
  total: number;
  current: number;
}

export default function SliderProgressBar(props: SliderProgressBarProps) {
  const { total, current } = props

  return (
    <Container>
      {Array.from({ length: total }).map((_, index) => (
        <ProgressLine
          key={index}
          isselected={current === index ? 1 : 0}
        />
      ))}
    </Container>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "row-reverse",
  gap: "4px",
  padding: "0 16px",
  position: "absolute",
  top: "58px",
  left: 0,
  zIndex: 1300
}))

type ProgressLineProps = {
  theme?: Theme;
  isselected: 1 | 0;
}

const ProgressLine = styled("div")(({ theme, isselected }: ProgressLineProps) => ({
  width: "100%",
  height: "6px",
  borderRadius: "4px",
  backgroundColor: isselected ? "#FFFFFF" : theme?.palette.gray["12"],
  transition: "0.2s"
}))
